import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';

export default class PurchaseOrderDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.partName = '';
		this.qtyPo = '';
		this.uom = '';
		this.priceUnit = '';
		this.subtotal = '';
		this.pricePpn = '';
		this.amount = '';
		this.qtyOutstanding = '';
		this.percentagePpn = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partId : '0',
			partPartNumber : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			partName : '0',
			qtyPo : '0',
			uom : '0',
			priceUnit : '0',
			subtotal : '0',
			pricePpn : '0',
			amount : '0',
			qtyOutstanding : '0',
			percentagePpn : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}